__turbopack_context__.v({
  "content": "CtaSection-module__pLBrYq__content",
  "ctaSection": "CtaSection-module__pLBrYq__ctaSection",
  "subtitle": "CtaSection-module__pLBrYq__subtitle",
  "title": "CtaSection-module__pLBrYq__title",
});
